// Restored from production OTA 2026-08-21 (module 1436).
import {
  FETCH_LANGUAGE,
  FETCH_LANGUAGE_SUCCESS,
  FETCH_LANGUAGE_FAILED,
  EDIT_LANGUAGE
} from "../store/types";
import { firebase } from '../config/configureFirebase';
import { onValue, push, set, remove } from "firebase/database";

export const fetchLanguages = () => (dispatch) => {
  const { languagesRef } = firebase;

  dispatch({
    type: FETCH_LANGUAGE,
    payload: null
  });
  onValue(
    languagesRef,
    (snapshot) => {
      console.log('[fetchLanguages] onValue fired, has data:', !!snapshot.val());
      if (snapshot.val()) {
        const data = snapshot.val();
        let defLang = null;
        const arr = Object.keys(data).map((i) => {
          data[i].id = i;
          if (data[i].default) {
            defLang = data[i].keyValuePairs;
          }
          return data[i];
        });
        dispatch({
          type: FETCH_LANGUAGE_SUCCESS,
          payload: {
            defaultLanguage: defLang,
            langlist: arr
          }
        });
      } else {
        dispatch({
          type: FETCH_LANGUAGE_FAILED,
          payload: "No Languages available."
        });
      }
    },
    (error) => {
      console.log('[fetchLanguages] onValue ERROR:', error && error.code, error && error.message);
      dispatch({
        type: FETCH_LANGUAGE_FAILED,
        payload: (error && error.message) || 'Failed to fetch languages'
      });
    }
  );
};

export const editLanguage = (lang, method) => (dispatch) => {
  const { languagesRef, languagesEditRef } = firebase;
  dispatch({
    type: EDIT_LANGUAGE,
    payload: { lang, method }
  });
  // material-table tags each row with its own tableData; keep it out of the database.
  const { tableData, ...record } = lang;
  if (method === 'Add') {
    push(languagesRef, record);
  } else if (method === 'Delete') {
    remove(languagesEditRef(lang.id));
  } else {
    set(languagesEditRef(lang.id), record);
  }
};
